export { default as bottomBlockTemplate } from './bottom-block.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/bottom-block/templates/index.ts